import api from "./api";

export default class AccomodationApi {
  static async Get() {
    return await api.get(`accomodation`);
  }
  static async GetAccomodation(id) {
    return await api.get(`accomodation/${id}`);
  }
  static async Post(data) {
    return await api.post(`accomodation`, data, "", {
      "Content-Type": "multipart/form-data",
    });
  }
  static async Patch(id, data) {
    return await api.patch(`accomodation/${id}`, data, "", {
      "Content-Type": "multipart/form-data",
    });
  }
  static async Del(id) {
    return await api.del(`accomodation/${id}`);
  }
}
